import { render, staticRenderFns } from "./the-thao-ao.vue?vue&type=template&id=08d25ce0&"
import script from "./the-thao-ao.vue?vue&type=script&lang=js&"
export * from "./the-thao-ao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports